<div class="ne-color-picker" data-test-component="color-chooser">
  <Header close="{() => store.set($store.showColorModal.toggle())}" logoSrc={$theme.logoSrc.state} />

  <Title>
    Choose a text color
  </Title>

  <Colors let:color={color}>
    <span class="ne-color-button" role="button" on:click="{() => chosenColor = color}">
    <Color hex="{color.hex.state}" isSelected="{chosenColor.hex.state === color.hex.state}"/>
    </span>
  </Colors>

  <div class="ne-button-container">
    <PrimaryButton trackingId='use message' buttonId='submit-color' click="{choose}">
      Use this color
    </PrimaryButton>
  </div>
</div>

<style>
  .ne-button-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: .5em;
  }

  .ne-color-picker {
    padding: 1em;
    background-color: #fff;
    display: block;
    position: relative;
    z-index: 1;
    max-height: 100%;
  }

  .ne-color-button {
    border-radius: 50%;
    overflow: hidden;
    margin: .25em 0;
  }
</style>

<script>
  import Title from './Title.html';
  import PrimaryButton from './PrimaryButton.html';
  import Messages from './Messages.html';
  import Header from './Header.html';
  import Colors from './Colors.html';
  import Color from './Color.html';
  import { store, theme } from '../stores';

  let chosenColor = $store.textColor;

  function choose() {
    store.set($store.setColor(chosenColor));
  }
</script>
